module.exports = __webpack_public_path__ + "img/pathStar.066b7431.svg";